import { useContext } from "react"
import OnColorContext from "@onestore/hel/dist/contexts/OnColorContext"
import isDarkOnColor from "@onestore/hel/dist/utils/isDarkOnColor"
import { useTheme } from "styled-components"

type HelThemeDataHookResults = {
  isDarkOnColorValue: boolean
}

export default function useHelThemeData(): HelThemeDataHookResults {
  const theme = useTheme()
  const onColor = useContext(OnColorContext)
  const isDarkOnColorValue = isDarkOnColor(theme, onColor)

  return {
    isDarkOnColorValue,
  }
}
